import { gql } from '@apollo/client/core';

export const updateMemberDataInOrganization = gql`
  mutation ($where: MemberToOrganizationInput!, $data: MemberDataInOrganization!) {
    admin {
      updateMemberDataInOrganization(where: $where, data: $data) {
        membersData {
          organizations {
            organization {
              code
            }
            role
            services {
              service
              role
            }
          }
        }
        adviseMessage {
          code
          description
        }
      }
    }
  }
`;
